export const GET_PROMO_STACK = 'GET_PROMO_STACK';
export const SET_PROMO_STACK = 'SET_PROMO_STACK';
export const ERROR_PROMO_STACK = 'ERROR_PROMO_STACK';